import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38dd730d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "View", -1))
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { class: "line-title mb-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"white-space":"nowrap"},
  class: "d-flex align-items-center col"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "line-visual" })
], -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Next Payment Due:", -1))
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Next Payment Due:", -1))
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Current Payment Method:", -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Previous Invoices", -1))
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Get Help", -1))
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Payment History", -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "d-flex justify-content-between align-items-center flex-wrap" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Your number:", -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Your number:", -1))
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Line:", -1))
const _hoisted_33 = { key: 3 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Activation Date:", -1))
const _hoisted_39 = { key: 5 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Source:", -1))
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Once Off Deals", -1))
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Upgrade / Downgrade", -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1))
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Recharge", -1))
const _hoisted_49 = ["onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Change Deal", -1))
const _hoisted_51 = ["onClick"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small" }, "Waiting for payment. Your new deal starts when you pay.", -1))
const _hoisted_53 = ["href"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pay now", -1))
const _hoisted_55 = {
  key: 1,
  class: "small"
}
const _hoisted_56 = {
  key: 5,
  class: "text-center my-10 no-data"
}

import { formatDate, formatNumber } from "@/utilities/index";
import DialogBox from "@/components/misc/DialogBox.vue";
import BundlePicker from "@/components/products/BundlePicker.vue";
import { migrateDdlGet, topUpDdlGet, cancelDdlGet, ordersIdPaymentGet } from "@/api/products";
import { ordersCancel, ordersMigratePut, ordersTopUpPut, initiateCardChange, OrderNewCardRef } from "@/api/orders";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "axios";
import { handleError } from "@/utilities/api";
import { computed, onBeforeMount, PropType, Ref, ref, watch } from "vue";
import { CustomerOrdersDto, ProductsListViewModel, OrderProductsDto, CancelationReasonsDto, CustomerOrderInvoicesDto, PagedResultOfOrderPaymentViewModel, CustomerOrdersDtoCustomerPaymentMethods } from "@/api-client";
import { Sell, Sort, DocumentDelete, Tickets, Phone, CreditCard, CirclePlusFilled, VideoPause, VideoPlay } from "@element-plus/icons-vue";
import { useMiscStore } from "@/stores/misc";
import Pagination from "@/components/misc/Pagination.vue";
import NewCardForm from "@/components/forms/NewCardForm.vue";
import { useRoute } from "vue-router";
import brand from "@/brand";
import { Payments } from "@/network/api";

type ActionName = "topUp" | "migrate" | "cancel";
type ActionDetail = {
  callback: Function;
  message: string;
  title: string;
  ddl: ProductsListViewModel[] | CancelationReasonsDto[] | null;
};
type OrderInvoices = {
  referenceNumber: string;
  invoices: CustomerOrderInvoicesDto[]
}
type OrderHistoryRef = {
  id: string;
  referenceNumber: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerProducts',
  props: {
  data: { required: true, type: Array as PropType<CustomerOrdersDto[]> },
  hasLoaded: { type: Boolean }
},
  emits: ["reload"],
  setup(__props, { emit: emits }) {

const props = __props;



// A branded portal (Vasco Mobile) shows only its own network's orders, and on them only the deal in force and
// any change waiting for payment. The Vasco Connect portal shows everything, as before.
const isBrandLine = (product: OrderProductsDto): boolean =>
  !!brand.provider && !product.isTopUp && product.products?.provider == brand.provider;
const visibleOrders = computed(() => !brand.provider
  ? (props.data || [])
  : (props.data || []).filter((order) => order.orderProducts.some(isBrandLine)));
const visibleLines = (order: CustomerOrdersDto): OrderProductsDto[] => !brand.provider
  ? order.orderProducts
  // New is a SIM still being activated: shown, without its actions, so a second SIM is visible from the day it is paid for.
  : order.orderProducts.filter((p) => isBrandLine(p) && ['New', 'Activated', 'PendingMigration'].includes(p.orderProductStatusesId));

// The order and line states in the customer's words; anything not listed shows as it is.
const statusNames: Record<string, string> = {
  New: "Being activated", NewOrder: "Waiting for your first payment", PendingActivation: "Being activated",
  Activated: "Active", PendingMigration: "Waiting for payment", Suspended: "Suspended",
};
const statusText = (status: string) => statusNames[status] || status;
const hasPendingChange = (order: CustomerOrdersDto): boolean =>
  order.orderProducts.some((p) => isBrandLine(p) && p.orderProductStatusesId == 'PendingMigration');

// The Peach link for each waiting change, read from the payment row the link was made for.
const pendingLinks: Ref<Record<string, string>> = ref({});
async function loadPendingLinks() {
  for (const order of visibleOrders.value) {
    const waiting = order.orderProducts.filter((p) => isBrandLine(p) && p.orderProductStatusesId == 'PendingMigration');
    if (!waiting.length) continue;
    try {
      const res = await Payments.apiOrdersOrdersIdPaymentGet(1, 20, order.id);
      for (const line of waiting) {
        const payment = (res.data.data || [])
          .filter((x) => x.orderProductsId == line.id && x.isSuccess == null && x.paymentProviderResponse)
          .sort((a, b) => b.dateTimeStamp.localeCompare(a.dateTimeStamp))[0];
        const url = payment ? JSON.parse(payment.paymentProviderResponse).url : null;
        if (url) pendingLinks.value[line.id] = url;
      }
    } catch {
      // No link to show; the customer still has it by email and SMS.
    }
  }
}
watch(() => props.data, loadPendingLinks, { immediate: true });

const statusMap: { [key: string]: string } = {
  false: 'danger',
  true: 'success'
}
const route = useRoute();

const miscStore = useMiscStore();
let actionDialogVisible: boolean = false;
// What a running payment action is doing; while set its button cannot be pressed again (4 Nov: a double tap paid twice).
const busy = ref("");
const cardBusy = ref(false);
const orderOf = (product: OrderProductsDto) => visibleOrders.value.find((o) => o.orderProducts.some((p) => p.id == product.id));
const cardOf = (order?: CustomerOrdersDto) => order?.customerPaymentMethods?.cardId
  ? `${order.customerPaymentMethods.cardType || "card"}${order.customerPaymentMethods.last4Digits ? ` ending in ${order.customerPaymentMethods.last4Digits}` : ""}` : null;
let invoiceDialogVisible: boolean = false;
let historyDialogVisible: boolean = false;
let dialogSelectedDdlId: Ref<number | null> = ref(null);
let dialogSelectedProduct: Ref<OrderProductsDto | null> = ref(null);
let dialogSelectedAction: Ref<ActionName | null> = ref(null);
// A Vasco Mobile line picks its bundle from the grouped cards; everything else keeps the drop-down.
const pickerFor = (action: ActionName | null) =>
  (action == "topUp" || action == "migrate") && !!dialogSelectedProduct.value && isBrandLine(dialogSelectedProduct.value) && !!dialogSelectedDdlId.value;
let selectedOrderInvoices: Ref<OrderInvoices | null> = ref(null)
let selectedOrderHistory: Ref<PagedResultOfOrderPaymentViewModel | null> = ref(null)
let selectedOrderHistoryRef: Ref<OrderHistoryRef | null> = ref(null)
let selectedOrderNewCard: Ref<OrderNewCardRef | null> = ref(null)
let historyPageSize: Ref<number> = ref(20);
let historyPageNumber: Ref<number> = ref(1);
const actions: Ref<Record<ActionName, ActionDetail>> = ref({
  topUp: {
    callback: () => topUp(),
    message: "",
    title: "Once Off Deals",
    ddl: [],
  },
  migrate: {
    callback: () => migrate(),
    message: "",
    title: "Upgrade / Downgrade",
    ddl: [],
  },
  cancel: {
    callback: () => cancel(),
    message: "",
    title: "Cancel",
    ddl: [],
  },
});
const hasHeader = (product: OrderProductsDto): boolean => { 
  // the '#…A' header is Telkom's order number; a Vasco Mobile line has none worth showing
  if (isBrandLine(product)) return false;
  if(product.productOrderReferenceNumber || product.isTopUp || product.products.productType == 'ROU') {
    return true;
  }
  return false;
}

onBeforeMount(async () => {
  miscStore.isLoadingOverride = true;

  actions.value.topUp.ddl = await topUpDdlGet();
  actions.value.migrate.ddl = await migrateDdlGet();
  actions.value.cancel.ddl = await cancelDdlGet();

  if(route.query.order) {
    cardResultMessage(route.query.order.toString());
  }
  
  miscStore.isLoadingOverride = false;
});

function cardResultMessage(query: string) {
  if (query == "null" || query == "error") {
    ElMessage.error({ message: "We couldn't save your new card. Please check the details and try again.", showClose: true, duration: 4000, dangerouslyUseHTMLString: true });
    console.warn("CARD UPDATE ERROR: " + (query == "null" ? "orderId or checkoutId was missing from the request" : "an error occurred when updating the card"))
  }
  else if (query) {
    ElMessage.success({ message: "Your card has been updated!", showClose: true, duration: 4000, dangerouslyUseHTMLString: true });
  }
}

function handleCardName(paymentType: CustomerOrdersDtoCustomerPaymentMethods) {
  return (paymentType.cardType ? paymentType.cardType : 'Card') +
    (paymentType.last4Digits ? ` ending in ${paymentType.last4Digits}` : '') +
    (paymentType.expiryMonth ? ` (expires ${paymentType.expiryMonth}/${paymentType.expiryYear})` : '')
}

function handleDate(date: any) {
  return formatDate(date);
}

async function handleAction(product: OrderProductsDto, action: ActionName) {
  actions.value.topUp.title = isBrandLine(product) ? "Recharge" : "Once Off Deals";
  actions.value.migrate.title = isBrandLine(product) ? "Change Deal" : "Upgrade / Downgrade";
  if (action == "topUp" && isBrandLine(product)) {
    actions.value.topUp.ddl = await axios.get(`${process.env.VUE_APP_ROOT_API}/api/products/topup/list?currentProductId=${product.products.id}`)
      .then((res) => res.data as ProductsListViewModel[])
      .catch((error) => { handleError(error); return []; });
    if (!actions.value.topUp.ddl?.length) {
      ElMessage.info({ message: "There are no recharges available right now.", showClose: true, grouping: true });
      return;
    }
  }
  if (action == "migrate" && isBrandLine(product)) {
    actions.value.migrate.ddl = await migrateDdlGet(product.products.id);
    // Paused billing resumes by paying for a deal, which may be the one they are on.
    const order = visibleOrders.value.find((o) => o.orderProducts.some((p) => p.id == product.id));
    if (order?.billingPausedDate) {
      actions.value.migrate.ddl = [{ id: product.products.id, vascoDealDescription: `${product.products.vascoDealDescription} - R${product.products.vascoPrice}`,
        name: `${product.products.vascoDealDescription} (your current deal)`, price: product.products.vascoPrice, details: product.products.vascoPackageDescription,
        category: (product.products as any).category } as ProductsListViewModel, ...(actions.value.migrate.ddl || [])];
    }
    if (!actions.value.migrate.ddl?.length) {
      ElMessage.info({ message: "There are no other deals to change to right now.", showClose: true, grouping: true });
      return;
    }
  }
  dialogSelectedProduct.value = product;
  dialogSelectedAction.value = action;
  handelActionDetail(product, action);
  actionDialogVisible = true;
}

function handelActionDetail(product: OrderProductsDto, action: ActionName) {
  switch (action) {
    case "topUp":
      if (isBrandLine(product)) {
        // Say how they will pay before they press Process (BRD FR-1.41: the stored card, with confirmation, or a link).
        const card = cardOf(orderOf(product));
        actions.value[action].message = `
          <div><b>Your number:</b> ${formatNumber(product.msisdn)}</div>
          <div class="mt-1">${card ? `We'll charge your ${card} now.` : "We'll send you a payment link by SMS and email."}</div>
        `;
        dialogSelectedDdlId.value = actions.value[action].ddl?.[0]?.id || null;
        break;
      }
      actions.value[action].message = `
        <div><b>Line:</b> ${product.msisdn}</div>
        <div>Please select an option:</div>
      `;
      dialogSelectedDdlId.value = actions.value[action].ddl?.[0].id || null;
      break;

    case "migrate":
      if (isBrandLine(product)) {
        actions.value[action].message = `
          <div><b>Your number:</b> ${formatNumber(product.msisdn)}</div>
          <div><b>Current:</b> ${product.products.vascoDealDescription} @ R${product.products.vascoPrice}pm</div>
          <div class="mt-2">We'll send you a payment link for the new deal's price. Please select a deal:</div>
        `;
        dialogSelectedDdlId.value = actions.value[action].ddl?.[0]?.id || null;
        break;
      }
      actions.value[action].message = `
        <div><b>Line:</b> ${product.msisdn}</div>
        <div><b>Current:</b> ${product.products.vascoDealDescription} @ R${product.products.vascoPrice}pm</div>
        <div>Please select an option:</div>
      `;
      dialogSelectedDdlId.value = product.products.id;
      break;

    case "cancel":
      actions.value[action].message = `
        <div><b>Line:</b> ${product.msisdn}</div>
        <div>Are you sure you want to cancel?</div>
        <div>Please select a reason for your cancellation:</div>
      `;
      dialogSelectedDdlId.value = actions.value[action].ddl?.[0].id || null;
      break;

    default:
      break;
  }
}

function handleActionClose() {
  dialogSelectedProduct.value = null;
  dialogSelectedAction.value = null;
  dialogSelectedDdlId.value = null;
  actionDialogVisible = false;
}

function selectOrderInvoices(order:CustomerOrdersDto) {
  selectedOrderInvoices.value = {
    referenceNumber: order.referenceNumber || "",
    invoices: order.orderInvoices.sort((a,b) => new Date(a.invoiceDate).getTime() - new Date(a.invoiceDate).getTime())
  }
  invoiceDialogVisible = true;
}

async function selectOrderHistory(order:CustomerOrdersDto | null = null) {
  selectedOrderHistoryRef.value = {
    id: order?.id || selectedOrderHistoryRef.value?.id || "",
    referenceNumber: order?.referenceNumber || selectedOrderHistoryRef.value?.referenceNumber || ""
  };
  selectedOrderHistory.value = await ordersIdPaymentGet(historyPageNumber.value, historyPageSize.value, selectedOrderHistoryRef.value?.id || "")
  historyDialogVisible = true;
}

async function orderCardChange(order:CustomerOrdersDto) {
  if (cardBusy.value) return;
  cardBusy.value = true;
  const cardChangeResponse = await initiateCardChange().then((r) => r.value).finally(() => cardBusy.value = false);
  if (cardChangeResponse) {
    selectedOrderNewCard.value = {
      orderId: order.id || "",    
      referenceNumber: order.referenceNumber || "",
      checkoutId: cardChangeResponse || ""
    }
  }
}

function handleInvoicesClose() {
  selectedOrderInvoices.value = null;
  invoiceDialogVisible = false;
}

function handleHistoryClose() {
  selectedOrderHistory.value = null;
  historyDialogVisible = false;
  selectedOrderHistoryRef.value = null;
}

function historyHandlePageSizeChange(size: number) {
  historyPageNumber.value = 1;
  historyPageSize.value = size;
  selectOrderHistory();
}

function historyHandlePageNumberClick(page: any) {
  historyPageNumber.value = page;
  selectOrderHistory();
}

function handleNewCardClose() {
  selectedOrderNewCard.value = null;
}

async function topUp() {
  if (dialogSelectedProduct.value?.msisdn) {
    const payload = {
      productsId: dialogSelectedDdlId.value as number,
      msisdn: dialogSelectedProduct.value.msisdn,
      isTopUp: true,
      ordersId: dialogSelectedProduct.value.ordersId
    }

    if (isBrandLine(dialogSelectedProduct.value)) {
      busy.value = cardOf(orderOf(dialogSelectedProduct.value)) ? "Charging your card…" : "Sending your payment link…";
      const said: Record<string, string> = {
        Loaded: "Paid. Your recharge is loading onto your SIM now.",
        CardPending: "We're waiting for your bank to confirm the payment. Your recharge loads as soon as it does.",
        LinkSent: "We couldn't charge your card, so a payment link is on its way by email and SMS. Your recharge loads when you pay."
      };
      await axios.put(`${process.env.VUE_APP_ROOT_API}/api/orders/products/${payload.msisdn}/topup`, payload)
        .then((res) => {
          ElMessage.success({ message: said[res.data?.topUpOutcome] || "Your recharge request has been received.", showClose: true, duration: 8000 });
          emits("reload");
        })
        .catch((error) => handleError(error, true, undefined, 8000))
        .finally(() => { busy.value = ""; handleActionClose(); });
      return;
    }

    await ordersTopUpPut(dialogSelectedProduct.value.msisdn, payload)
      .then(() => {
        emits("reload");
        handleActionClose();
      })
      .catch(() => {
        handleActionClose();
      });
  } else {
    ElMessage.error({ message: "An error has occurred - MSISDN is required.", showClose: true, grouping: true });
    handleActionClose();
  }
}

async function migrate() {
  if (dialogSelectedProduct.value?.msisdn) {
    const payload = {
      productsId: dialogSelectedDdlId.value as number,
      msisdn: dialogSelectedProduct.value.msisdn,
      isTopUp: false,
      ordersId: dialogSelectedProduct.value.ordersId
    }
    const branded = isBrandLine(dialogSelectedProduct.value);
    if (branded) busy.value = "Sending your payment link…";
    await ordersMigratePut(dialogSelectedProduct.value.msisdn, payload)
      .finally(() => busy.value = "")
      .then(() => {
        if (branded) {
          ElMessage.success({ message: "Your payment link is on its way by email and SMS. Your new deal starts when you pay.", showClose: true, duration: 6000 });
        }
        emits("reload");
        handleActionClose();
      })
      .catch(() => {
        handleActionClose();
      });
  } else {
    ElMessage.error({ message: "An error has occurred - MSISDN is required.", showClose: true, grouping: true });
    handleActionClose();
  }
}

// A line is never closed, so pausing is the customer's way out: no more bills, the data on the SIM runs out.
async function setPaused(order: CustomerOrdersDto, product: OrderProductsDto, paused: boolean) {
  const message = paused
    ? `<ul class="ps-4 mb-0">
        <li>You can resume any time.</li>
      </ul>`
    : "Billing carries on from your next bill day.";
  // The box stays open with its button busy until the answer, so the request cannot be sent twice.
  await ElMessageBox.confirm(message, paused ? "Pause billing?" : "Resume billing?", {
    dangerouslyUseHTMLString: true, confirmButtonText: paused ? "Pause" : "Resume", cancelButtonText: "Keep as is",
    beforeClose: (action, instance, done) => {
      if (action != "confirm") return done();
      instance.confirmButtonLoading = true;
      instance.confirmButtonText = paused ? "Pausing…" : "Resuming…";
      axios.put(`${process.env.VUE_APP_ROOT_API}/api/orders/products/${product.msisdn}/billing-pause?paused=${paused}`)
        .then(() => {
          ElMessage.success({ message: paused ? "Billing paused." : "Billing resumed.", showClose: true });
          emits("reload");
        })
        .catch((error) => handleError(error, true, undefined, 8000))
        .finally(() => { instance.confirmButtonLoading = false; done(); });
    }
  }).catch(() => undefined);
}

async function cancel() {
  if (dialogSelectedProduct.value?.msisdn) {
    await ordersCancel(dialogSelectedProduct.value.msisdn, dialogSelectedDdlId.value as number)
      .then(() => {
        emits("reload");
        handleActionClose();
      })
      .catch(() => {
        handleActionClose();
      });
  } else {
    ElMessage.error({ message: "An error has occurred - MSISDN is required.", showClose: true, grouping: true });
    handleActionClose();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(dialogSelectedAction))
      ? (_openBlock(), _createBlock(DialogBox, {
          key: 0,
          title: actions.value[_unref(dialogSelectedAction)].title,
          onConfirm: actions.value[_unref(dialogSelectedAction)!].callback,
          onClose: handleActionClose,
          confirmText: "Process",
          busyText: busy.value,
          dialogVisible: _unref(actionDialogVisible)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "action-text",
              innerHTML: actions.value[_unref(dialogSelectedAction)].message
            }, null, 8, _hoisted_2),
            (pickerFor(_unref(dialogSelectedAction)))
              ? (_openBlock(), _createBlock(BundlePicker, {
                  key: 0,
                  bundles: (actions.value[_unref(dialogSelectedAction)].ddl as any),
                  modelValue: _unref(dialogSelectedDdlId),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogSelectedDdlId) ? (dialogSelectedDdlId).value = $event : dialogSelectedDdlId = $event))
                }, null, 8, ["bundles", "modelValue"]))
              : (actions.value[_unref(dialogSelectedAction)].ddl && _unref(dialogSelectedDdlId))
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    filterable: "",
                    class: "mt-2",
                    modelValue: _unref(dialogSelectedDdlId),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialogSelectedDdlId) ? (dialogSelectedDdlId).value = $event : dialogSelectedDdlId = $event)),
                    placeholder: "Filter by role"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value[_unref(dialogSelectedAction)].ddl, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: (item as CancelationReasonsDto).reason || (item as ProductsListViewModel).vascoDealDescription,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "onConfirm", "busyText", "dialogVisible"]))
      : _createCommentVNode("", true),
    (_unref(selectedOrderInvoices))
      ? (_openBlock(), _createBlock(DialogBox, {
          key: 1,
          title: `${_unref(selectedOrderInvoices).referenceNumber} Previous Invoices`,
          onClose: handleInvoicesClose,
          confirmVisible: false,
          closeText: "Close",
          dialogVisible: _unref(invoiceDialogVisible)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              style: {"width":"100%"},
              "max-height": "50vh",
              id: "invoiceTable",
              border: "",
              "row-key": "id",
              "empty-text": "No data available",
              ref: "table",
              data: _unref(selectedOrderInvoices).invoices
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  "min-width": "80",
                  prop: "invoiceNumber",
                  label: "#"
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "120",
                  prop: "invoiceDate",
                  label: "Invoice Date"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(handleDate(row.invoiceDate)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  fixed: "right",
                  width: "80",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_router_link, {
                      target: "_blank",
                      to: { name: 'ViewInvoice', params: { invoiceId: row.id }},
                      class: "pointer",
                      title: "View Invoice"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }, 8, ["title", "dialogVisible"]))
      : _createCommentVNode("", true),
    (_unref(selectedOrderHistory))
      ? (_openBlock(), _createBlock(DialogBox, {
          key: 2,
          title: `${_unref(selectedOrderHistoryRef)?.referenceNumber} Payment History`,
          onClose: handleHistoryClose,
          confirmVisible: false,
          closeText: "Close",
          dialogVisible: _unref(historyDialogVisible)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              style: {"width":"100%"},
              "max-height": "50vh",
              id: "historyTable",
              border: "",
              "row-key": "id",
              "empty-text": "No data available",
              ref: "table",
              data: _unref(selectedOrderHistory).data
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  "min-width": "100",
                  prop: "paymentDateTime",
                  label: "Date",
                  fixed: "left"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(handleDate(row.paymentDateTime)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "100",
                  prop: "amount",
                  label: "Amount"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, "R" + _toDisplayString(row.amount.toFixed(2)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "90",
                  prop: "isSuccess",
                  label: "Status"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_tag, {
                        size: "small",
                        effect: "dark",
                        type: row.isSuccess == null ? 'info' : statusMap[row.isSuccess]
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("small", null, _toDisplayString(row.isSuccess == null ? "Pending" : row.isSuccess ? "Successful" : "Failed"), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "130",
                  prop: "paymentType",
                  label: "Payment Type"
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "140",
                  prop: "customerPaymentMethodsPaymentMethod",
                  label: "Payment Method"
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "110",
                  prop: "customerPaymentMethodsCardType",
                  label: "Card Type"
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "180",
                  prop: "customerPaymentMethodsHolder",
                  label: "Card Holder"
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "110",
                  prop: "customerPaymentMethodsLast4Digits",
                  label: "Card Ending"
                }),
                _createVNode(_component_el_table_column, {
                  "min-width": "100",
                  prop: "customerPaymentMethodsExpiry",
                  label: "Card Expiry"
                }, {
                  default: _withCtx(({ row }) => [
                    (row.customerPaymentMethodsExpiryMonth)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(row.customerPaymentMethodsExpiryMonth) + "/" + _toDisplayString(row.customerPaymentMethodsExpiryYear), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(Pagination, {
              data: _unref(selectedOrderHistory),
              pageSize: +_unref(historyPageSize),
              currentPage: +_unref(historyPageNumber),
              onChange: historyHandlePageNumberClick,
              onChangeSize: historyHandlePageSizeChange,
              disableToTop: true
            }, null, 8, ["data", "pageSize", "currentPage"])
          ]),
          _: 1
        }, 8, ["title", "dialogVisible"]))
      : _createCommentVNode("", true),
    (_unref(selectedOrderNewCard))
      ? (_openBlock(), _createBlock(DialogBox, {
          key: 3,
          title: `Add New Card to ${_unref(selectedOrderNewCard).referenceNumber}`,
          onClose: handleNewCardClose,
          confirmVisible: false,
          closeText: "Cancel",
          dialogVisible: _unref(selectedOrderNewCard) != null
        }, {
          default: _withCtx(() => [
            _createVNode(NewCardForm, { newCardRequest: _unref(selectedOrderNewCard) }, null, 8, ["newCardRequest"])
          ]),
          _: 1
        }, 8, ["title", "dialogVisible"]))
      : _createCommentVNode("", true),
    (visibleOrders.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleOrders.value, (order, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({ 'mb-5': i != visibleOrders.value.length - 1 })
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(order.referenceNumber) + "  ", 1),
                _hoisted_7
              ]),
              _createVNode(_component_el_card, {
                class: "box-card mb-2 order-overview",
                shadow: "never",
                style: {"background-color":"#f6f8fa"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    type: "flex",
                    gutter: 20,
                    class: "flex-wrap"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 24,
                        sm: 15,
                        md: 15,
                        class: "product-info"
                      }, {
                        default: _withCtx(() => [
                          (order.orderSubStateId)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _hoisted_9,
                                _createTextVNode(" " + _toDisplayString(_unref(brand).provider ? statusText(order.orderSubStateId) : order.orderSubStateId), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (order.billingPausedDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _hoisted_11,
                                _createTextVNode(" None, billing paused")
                              ]))
                            : (order.nextBillingDate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createTextVNode(" " + _toDisplayString(handleDate(order.nextBillingDate)), 1)
                                ]))
                              : _createCommentVNode("", true),
                          (order.customerPaymentMethods)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(handleCardName(order.customerPaymentMethods)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        class: "actions",
                        xs: 24,
                        sm: 9,
                        md: 9
                      }, {
                        default: _withCtx(() => [
                          (order.orderInvoices.length)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: ($event: any) => (selectOrderInvoices(order))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Tickets))
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(),
                                _hoisted_17
                              ], 8, _hoisted_16))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            target: "_blank",
                            href: _unref(brand).provider ? 'https://vascomobile.co.za/' : 'https://vascoconnect.co.za/pages/contact-us'
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Phone))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(),
                            _hoisted_19
                          ], 8, _hoisted_18),
                          _createElementVNode("div", {
                            onClick: ($event: any) => (selectOrderHistory(order))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CreditCard))
                              ]),
                              _: 1
                            }),
                            _createTextVNode(),
                            _hoisted_21
                          ], 8, _hoisted_20),
                          _createElementVNode("div", {
                            onClick: ($event: any) => (orderCardChange(order))
                          }, [
                            _createVNode(_component_el_icon, { class: "new-card-icon" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CreditCard)),
                                _createVNode(_unref(CirclePlusFilled), { class: "plus" })
                              ]),
                              _: 1
                            }),
                            _createTextVNode(),
                            _createElementVNode("span", null, _toDisplayString(cardBusy.value ? "Opening the card form…" : "Change Payment Card"), 1)
                          ], 8, _hoisted_22)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleLines(order), (product, j) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  class: _normalizeClass(["box-card line-card", { 'mb-2': j != visibleLines(order).length - 1 }]),
                  shadow: "never"
                }, _createSlots({
                  default: _withCtx(() => [
                    (['LTE', 'TOP', 'ROU'].includes(product.products.productType) || isBrandLine(product))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: product.id
                        }, [
                          _createVNode(_component_el_row, {
                            type: "flex",
                            gutter: 20,
                            class: "flex-wrap"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 24,
                                class: "product-info"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass({ 'mb-3': product.products.productType == 'LTE' && !product.isTopUp })
                                  }, [
                                    _createElementVNode("b", null, [
                                      _createElementVNode("u", null, _toDisplayString(product.products.vascoDealDescription) + " @ R" + _toDisplayString(product.products.vascoPrice) + "pm", 1)
                                    ])
                                  ], 2)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, {
                                xs: 24,
                                sm: 15,
                                md: 15,
                                class: "product-info"
                              }, {
                                default: _withCtx(() => [
                                  (product.msisdn && isBrandLine(product))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _hoisted_28,
                                        _createTextVNode(" " + _toDisplayString(_unref(formatNumber)(product.msisdn)), 1)
                                      ]))
                                    : (isBrandLine(product))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                          _hoisted_30,
                                          _createTextVNode(" on its way once your SIM is active")
                                        ]))
                                      : (product.msisdn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _hoisted_32,
                                            _createTextVNode(" " + _toDisplayString(product.msisdn), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                  (isBrandLine(product) && product.orderProductStatusesId == 'PendingMigration')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _hoisted_34,
                                        _createTextVNode(" Waiting for payment")
                                      ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                        (product.orderProductStatusesId)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                              _hoisted_36,
                                              _createTextVNode(" " + _toDisplayString(isBrandLine(product) ? statusText(product.orderProductStatusesId) : product.orderProductStatusesId), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (product.activationDate)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                              _hoisted_38,
                                              _createTextVNode(" " + _toDisplayString(handleDate(product.activationDate)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64)),
                                  (product.changeSource)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _hoisted_40,
                                        _createTextVNode(" " + _toDisplayString(product.changeSource), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              (product.products.productType == 'LTE' && !product.isTopUp && !isBrandLine(product))
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 0,
                                    class: "actions",
                                    xs: 24,
                                    sm: 9,
                                    md: 9
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (handleAction(product, 'topUp'))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Sell))
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(),
                                        _hoisted_42
                                      ], 8, _hoisted_41),
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (handleAction(product, 'migrate'))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Sort))
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(),
                                        _hoisted_44
                                      ], 8, _hoisted_43),
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (handleAction(product, 'cancel'))
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(DocumentDelete))
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(),
                                        _hoisted_46
                                      ], 8, _hoisted_45)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (isBrandLine(product))
                                  ? (_openBlock(), _createBlock(_component_el_col, {
                                      key: 1,
                                      class: "actions",
                                      xs: 24,
                                      sm: 9,
                                      md: 9
                                    }, {
                                      default: _withCtx(() => [
                                        (product.orderProductStatusesId == 'Activated')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              onClick: ($event: any) => (handleAction(product, 'topUp'))
                                            }, [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(Sell))
                                                ]),
                                                _: 1
                                              }),
                                              _createTextVNode(),
                                              _hoisted_48
                                            ], 8, _hoisted_47))
                                          : _createCommentVNode("", true),
                                        (product.orderProductStatusesId == 'Activated' && !hasPendingChange(order))
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 1,
                                              onClick: ($event: any) => (handleAction(product, 'migrate'))
                                            }, [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(Sort))
                                                ]),
                                                _: 1
                                              }),
                                              _createTextVNode(),
                                              _hoisted_50
                                            ], 8, _hoisted_49))
                                          : _createCommentVNode("", true),
                                        (product.orderProductStatusesId == 'Activated' && !hasPendingChange(order))
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              onClick: ($event: any) => (setPaused(order, product, !order.billingPausedDate))
                                            }, [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  (!order.billingPausedDate)
                                                    ? (_openBlock(), _createBlock(_unref(VideoPause), { key: 0 }))
                                                    : (_openBlock(), _createBlock(_unref(VideoPlay), { key: 1 }))
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createTextVNode(),
                                              _createElementVNode("span", null, _toDisplayString(order.billingPausedDate ? "Resume Billing" : "Pause Billing"), 1)
                                            ], 8, _hoisted_51))
                                          : _createCommentVNode("", true),
                                        (product.orderProductStatusesId == 'PendingMigration')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _hoisted_52,
                                              (pendingLinks.value[product.id])
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: pendingLinks.value[product.id],
                                                    target: "_blank"
                                                  }, [
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_unref(CreditCard))
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createTextVNode(),
                                                    _hoisted_54
                                                  ], 8, _hoisted_53))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_55, "We've sent the payment link to your email and phone."))
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, [
                  (hasHeader(product))
                    ? {
                        name: "header",
                        fn: _withCtx(() => [
                          _createElementVNode("div", _hoisted_23, [
                            (product.productOrderReferenceNumber)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "#" + _toDisplayString(product.productOrderReferenceNumber) + "A", 1))
                              : (product.isTopUp)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Once Off Deals"))
                                : (product.products.productType == 'ROU')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Router"))
                                  : _createCommentVNode("", true)
                          ])
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["class"]))
              }), 256))
            ], 2))
          }), 256))
        ]))
      : (__props.hasLoaded && !_unref(miscStore).isLoading)
        ? (_openBlock(), _createElementBlock("i", _hoisted_56, "No product information available."))
        : _createCommentVNode("", true)
  ]))
}
}

})